module.exports = __webpack_public_path__ + "static/media/trash.fcc0597d.svg";